import store from '@/store'

export default {
    $http : null,
    getEnums(next) {
        if(store.enum.enums){
            next();
        }else{
            this.$http.get(store.ctx + "/msu/admin/enums").then((response) =>{
                store.enum.enums = response.data;
                next();
            });
        }
    },
    filterFormat(value, enumfullname) {
        return store.enum.enums[enumfullname][value];
    }
}


// WEBPACK FOOTER //
// ./src/components/enums/index.js